module.exports = __webpack_public_path__ + "img/ic_hotel_card_arrow_left.8ff1a856.svg";